export class UsuarioLogado {
  constructor({ id, nome, email, permissoes, idTabela, perfil }) {
    this.id = id;
    this.nome = nome;
    this.email = email;
    this.permissoes = permissoes;
    this.idTabela = idTabela;
    this.perfil = perfil;
  }

  get primeiraLetraNome() {
    return this.nome.charAt(0);
  }
}
